import { BaseEditable } from '@fmcc-web-platform/react-components';
import React from 'react';
import styled from '@emotion/styled';

const Main = styled.main`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const withMainContainer = (Component: React.FC<any>) => {
  const WrapperComponent = (props: { model: object & { isMain: boolean } } & BaseEditable) => {
    if (Component && props.model.isMain) {
      return (
        <Main id="main-content">
          <Component {...props} />
        </Main>
      );
    }

    return <Component {...props} />;
  };
  WrapperComponent.displayName = `withMainContainer(${Component.displayName || Component.name})`;
  return WrapperComponent;
};

export default withMainContainer;
